import axios from './configAxios';

export const getOrderApi = async (order_id) => {
	return await axios.get(`/1/${order_id}/`);
};
